// import Swiper from '../../js/vendor/swiper.min.js';
import jsLoader from '../../js/lib/jsLoader';

const detectMobile = () => {
	if(window.matchMedia)
		return window.matchMedia("(max-width: 991px)").matches;
}

let sliders = document.querySelectorAll('.js-gallery');
if (sliders.length > 0) {
	const swiperInit = () => {
		let swiperAvailable = false;
		let swiper;
		let galleryOptions;
		// Loaded?
		for (var i = 0; i < sliders.length; i++) {
			sliders[i].setAttribute('loaded', true)
		}

		// For Cards
		if (sliders[0].dataset.type === "cards") {
			const cardBreakpoints = {
				1480: {
					slidesPerView: 3.5
					// spaceBetween: 30
				},
				991: {
					slidesPerView: 2.5
					// spaceBetween: 30
				},
				680: {
					slidesPerView: 1.1,
					spaceBetween: 10
				}
			}
			swiper = new Swiper('.js-gallery', {
				breakpoints: cardBreakpoints,
				slidesPerView: 4.5,
				spaceBetween: 30,
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev'

			});
		} else {
			galleryOptions = {
				slidesPerView: 5,
				roundLengths: true,
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				breakpoints: {
					991: {
						slidesPerView: 3.5,
						spaceBetween: 30
					},
					768: {
						spaceBetween: 15
					},
					680: {
						slidesPerView: 2.5,
						spaceBetween: 15
					},
					470: {
						slidesPerView: 1.5
					}
				}
			};
			const createGallerySlider = () => {
				if (detectMobile()) {
					swiperAvailable = true;
					swiper = new Swiper('.js-gallery', galleryOptions);
				}
			}
			const updateGallerySlider = () => {
				if (detectMobile() && swiperAvailable === false) {
					swiperAvailable = true;
					swiper = new Swiper('.js-gallery', galleryOptions);
				} else if (!detectMobile() && swiperAvailable === true) {
					swiperAvailable = false;
					sliders.forEach((item) => {
						item.swiper.destroy();
					});
				}
			}
			createGallerySlider();
			window.addEventListener('resize', () => {
				updateGallerySlider();
			});
		}
	}
	jsLoader.load("/js/vendor/swiper.min.js", () => {
		swiperInit();
	});

}



// WEBPACK FOOTER //
// ../components/gallery/gallery.js